module.exports = __webpack_public_path__ + "static/img/logo_slogan_xs.6aba1c5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newSpark/logo_slogan_xs.svg
// module id = r/cd
// module chunks = 12